export default __webpack_public_path__ + "static/media/auth-illustrations.a9753152.png";